import React from 'react';
import { connect } from 'react-redux';
import { Nav, NavItem, NavLink } from 'reactstrap';
import Logs from '../components/Logs';
import ReactGA from '../../../utils/analytics';

class WeatherObsExercises extends React.Component {
  constructor() {
    super();

    this.state = {
      selectedIndex: 0,
      exercises: [],
      headers: [
        {caption: 'Time', field: 'weatherobs_datetime', firstRowValue: '05:50'},
        {caption: 'Heading (CC)', field: 'weatherobs_heading', firstRowValue: '120'},
        {caption: 'Speed (SOG)', field: 'weatherobs_sog', firstRowValue: '12'},
        {caption: 'Log Distance', field: 'weatherobs_log_distance', firstRowValue: '0'},
        {caption: 'Total Distance', field: 'weatherobs_total_distance', firstRowValue: '0'},
        {caption: 'Wind Scale (Beaufort)', field: 'weatherobs_wind_scale', firstRowValue: '2'},
        {caption: 'Wind Direction', field: 'weatherobs_wind_direction', firstRowValue: 'SSE'},
        {caption: 'Sea State', field: 'weatherobs_sea_state', firstRowValue: '2'},
        {caption: 'Weather', field: 'weatherobs_weather_scale', firstRowValue: 'b'},
        {caption: 'Visibility', field: 'weatherobs_visibility', firstRowValue: '7'},
        {caption: 'Barometer', field: 'weatherobs_barometer', firstRowValue: '1024'}
      ]
    }

    this.renderPane = this.renderPane.bind(this);
  }

  componentDidMount() {
    const { data } = this.props;
    const { headers } = this.state;
    let { exercises } = this.props.weatherobs;

    if (exercises.length === 0) {
      let answer = {}
      headers.map(header => {
        answer[header.field] = {value: '', className: '', reason: ''};
      });

      exercises = data.map((exercise, index) => ({...exercise, answer, id: index}));
    }

    this.props.dispatch({type: `SET_WEATHEROBS_EXERCISES_FULFILLED`, payload: exercises});

    // Collect data for Google Analytics
    ReactGA.event({
      category: 'Browsing WeatherObs Exercises',
      action: 'WeatherObs Exercises Page'
    });
  }

  renderTabs() {
    const { exercises } = this.props.weatherobs;

    return exercises.map((exercise, index) =>{
      return {
        name: `${exercise.id}`,
        title: `Exercise ${index + 1}`,
        className: 'tab-one',
        data: exercise
      }
    })
  }

  renderPane(tab) {
    // Set wheelhouse reducer
    this.props.dispatch({type: `SET_COMPASS_FULFILLED`, payload: {heading: tab.data.weatherobs_heading}});
    this.props.dispatch({type: `SET_ANEMOMETER_FULFILLED`, payload: {direction: tab.data.weatherobs_wind_direction, speed: 0, showSpeed: false, showDirection: false}});
    this.props.dispatch({type: `SET_BAROMETER_FULFILLED`, payload: {hpa: tab.data.weatherobs_barometer}});
    this.props.dispatch(
      {
        type: `SET_GPS_FULFILLED`,
        payload:
          {
            title: 'Satellite #4',
            lng: `31\u00B0 14.74334'N`,
            lat: `121\u00B0 23.742234'E`,
            sog :`${tab.data.weatherobs_sog}kts`,
            datetime: tab.data.weatherobs_datetime,
            cog: '-'
          }
      }
    );

    return (
      <div className="p-3">
        <div style={{ whiteSpace: 'pre-line' }}>{tab.data.weatherobs_question}</div>
      </div>
    )
  }

  render() {
    const { exercises } = this.props.weatherobs;
    const { headers, selectedIndex } = this.state;
    const tabs = this.renderTabs();
    const activeTab = tabs[selectedIndex] || tabs[0];

    return (
      <div className="mt-4">
        <Nav tabs className="wp-tab-panel">
          {tabs.map((tab, index) => (
            <NavItem key={tab.name}>
              <NavLink
                active={index === selectedIndex}
                className={index === selectedIndex ? 'active-tab' : ''}
                onClick={() => this.setState({ selectedIndex: index })}
              >
                {tab.title}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        {activeTab && this.renderPane(activeTab)}

        <div className="p-1 d-flex justify-content-between border-top border-gray rounded">
          <div>Vessel Name: <span className="font-bolder">M/S Mary Jane</span></div>
          <div>Log Date: <span className="font-bolder">2024-10-22</span></div>
        </div>
        <Logs onCheck={this.onCheck} headers={headers} exercises={exercises} selectedIndex={selectedIndex} />
        <small><span className="font-bolder">Verify your result - </span>Click Check button on each row to your result. <span className="text-danger">Red means unexpected values. </span><span className="text-warning">Yellow/Orange means blank values where there shouldnt be.</span> <span className="text-black">White background means good result. </span>Hover over values to find out more about yours vs expected values</small>
      </div>
    );
  }
}

const mapStoreToProps = (store) => ({
  weatherobs: store.weatherobs
});

export default connect(mapStoreToProps)(WeatherObsExercises);
